"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const config_routes_1 = __importDefault(require("./config-routes"));
const routes = [
    {
        path: '/',
        component: () => Promise.resolve().then(() => __importStar(require('@/views/layout/index.vue'))),
        redirect: '/home',
        children: [
            ...config_routes_1.default,
            {
                path: '/error/:code',
                name: 'error',
                props: ({ params = {} }) => (Object.assign({}, params)),
                component: () => Promise.resolve().then(() => __importStar(require('@/views/error/index.vue')))
            }
        ]
    },
    // {
    //   path: '/car',
    //   name: 'car',
    //   component: () => import('@/views/pages/car/index.vue')
    // },
    // {
    //   path: '/hotProduct',
    //   name: 'hotProduct',
    //   component: () => import('@/views/pages/hotProduct/index.vue')
    // },
    // {
    //   path: '/brand',
    //   name: 'brand',
    //   component: () => import('@/views/pages/brand/index.vue')
    // },
    // {
    //   path: '/order',
    //   name: 'order',
    //   component: () => import('@/views/pages/order/index.vue')
    // },
    // {
    //   path: '/productType',
    //   name: 'productType',
    //   component: () => import('@/views/pages/productType/index.vue')
    // },
    // {
    //   path: '/goodDetail/:id',
    //   name: 'goodDetail',
    //   component: () => import('@/views/pages/goodDetail/index.vue')
    // },
    // {
    //   path: '/forgetPwd',
    //   name: 'forgetPwd',
    //   component: () => import('@/views/login/forgetPwd.vue')
    // },
    // {
    //   path: '/register',
    //   name: 'register',
    //   component: () => import('@/views/login/register.vue')
    // },
    // DON'T CHANGE BELOW
    {
        path: '/login',
        name: 'login',
        component: () => Promise.resolve().then(() => __importStar(require('@/views/login/index.vue')))
    },
    // 跳转到home
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '*',
        redirect: '/error/404'
    }
];
exports.default = routes;
